import Image from "next/image";

export function BrandName({ name, logo = false }: { name: string; logo?: boolean }) {
  if (logo) return <Image src="/brand/seero-logo.svg" alt="seero.ru" width={1185} height={310} className="h-9 w-auto brightness-0 invert sm:h-10" preload />;
  const displayName = name === "SPLAT.STUDIO" ? "seero.ru" : name;
  const dot = displayName.indexOf(".");
  if (dot < 0) return <>{displayName}</>;
  return <>{displayName.slice(0, dot)}<span className="text-primary">.</span>{displayName.slice(dot + 1)}</>;
}
